import React from "react"

export const UnexpectedErrorText: React.ReactNode = <>
    Something unexpected happened. Please refresh your page and try 
    going through the steps to purchase again. If you see this error 
    multiple times, please reach out to us on <a href="https://discord.gg/everseed">Discord.</a>
</>
